import { memo } from "react";
import { Pressable } from "react-native";
import { useUnistyles } from "react-native-unistyles";
import { Icon } from "@src/components/Icon";
import { View } from "@src/components";
import { styles } from "./CamerasTabHeader.native";
import type { FC } from "react";
import type { SharedHeaderProps } from "./CamerasTabHeader.native";

type Props = Pick<SharedHeaderProps, "onSearchPress"> & {
  variant: "legacy" | "siteWide";
};

export const CamerasTabHeaderActions: FC<Props> = memo(({ onSearchPress, variant }) => {
  const { theme } = useUnistyles();
  const iconStyle = variant === "legacy" ? styles.legacyIconBtn : styles.iconBtn;
  const iconColor = theme.colors.textMuted;

  return (
    <View flexDirection="row" alignItems="center" gap="xs">
      <Pressable
        style={iconStyle}
        onPress={onSearchPress}
        accessibilityRole="button"
        accessibilityLabel="Search cameras"
      >
        <Icon name="search" size={24} color={iconColor} />
      </Pressable>
    </View>
  );
});

CamerasTabHeaderActions.displayName = "CamerasTabHeaderActions";
